<template>
    <div id="order-processed-vue" class="container-fluid">
        <div class="container">
            <div class="row botrow">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="text-right">
                        <a href="#" @click.prevent="printPage()"><!-- a.print triggers window print in Jquery scripts.js-->
                            <i class="csi-iconfont csi-print small"></i>{{ labels[1112] }}<!-- Print Confirmation -->
                        </a>
                    </div>
                    <div v-html="completeMsg"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import router from "../router"
import useCMS from "../../shared/composables/useCMS"
import useUtils from "../../shared/composables/useUtils"
import useCheckout from "../composables/useCheckout"
import useSessionKeeper from "../composables/useSessionKeeper"

export default {
    name: 'CheckoutComplete',
    setup () {
        const { labels, getDynamicMessage } = useCMS();
        const { printPage } = useUtils();
        const { orderProcessed, checkoutUser } = useCheckout();
        const { cancelSessionTimer } = useSessionKeeper();

        const completeMsg = ref('');

        //no longer need to keep track of session timer
        cancelSessionTimer();

        getDynamicMessage(5,{
            orderId: orderProcessed.value.orderId,
            userEmail: checkoutUser.value.email,
            hasDownload: (orderProcessed.value.hasDownloads ? orderProcessed.value.hasDownloads : false)
        }).then((resp) => {
            if(resp.status == 200) {
                completeMsg.value = resp.data;
            }
        }).catch((error) => {
            //just show this in case there is some problem getting the dynamic message
            completeMsg.value = "Your order has been completed. You confirmation email has been sent to your email address. Thank you for choosing Campbell Scientific.";
            console.log(error);
        });

        //should have an order id here
        if (!orderProcessed.value.orderId) {
            router.push('/');
            alert('No order ID exists. You have been redirected to the cart.');
        }

        return {
            labels,
            completeMsg,
            printPage
        }
    }
}
</script>
